// removed by extract-text-webpack-plugin
module.exports = {"nav":"_2Dx2YDVsUGtok9zcXsrxYV","link":"_3iM9ka7MZn5P6VtJEpy4","active":"_7VM4PVHk3XHgpYjTBCs76"};


//////////////////
// WEBPACK FOOTER
// ./src/Nav.css
// module id = 232
// module chunks = 0